import React from "react";
import { connect } from "react-redux";
import axios from 'axios';
import _ from "lodash";
import moment from 'moment';
import { samanAction, professionalAction } from "../../_actions";

import { SamanForm } from "./addform/SamanForm";
import { Button, Form, Input, Select, Drawer, message, Modal, Spin } from 'antd';
import { LCBForm } from "./addform/LCBForm";
import { PSForm } from "./addform/PSForm";

// const baseUrl = 'https://www.criminalmis.in/api';
const baseUrl = 'http://localhost:8080/api';
const SamansTable = React.lazy(() =>
  import('./samanstable').then(module => ({
    default: module.SamansTable
  }))
);

class Samans extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    isCreateFormVisible: false,
    isresetform: true,
    loading: false,
    samansList: [],
    isform1Visible: false,
    isform2Visible: false,
    updateSaman: {},
  };

  userForm = React.createRef();
  lsbForm = React.createRef();
  psForm = React.createRef();

  componentDidMount() {
    const { user } = this.props;
    if (user) {
      this.setState({ loading: true });
      samanAction.getSamansInformation().then(res => {
        if (res.length) {
          this.setState({ loading: false, samansList: res });

        }
      });
    }
  }

  onFormSave = (values) => {
    this.userForm.current.onFinish(true);
  };

  onFormFinish = (values) => {
    if (values.uploadchargesheet && values.uploadchargesheet.fileList.length) {
      this.setState((prevState) => ({ isCreateFormVisible: false }));

      values.files = values.uploadchargesheet;
      delete values.uploadchargesheet;
      this.uploadImage(values, 'create');
    } else if (values.uploadpssheet && values.uploadpssheet.fileList.length) {
      values.files = values.uploadpssheet;
      delete values.uploadpssheet;
      this.uploadImage(values, 'ps');
    }
  }


  uploadImage = async (options, type) => {
    const { files } = options;
    const { user } = this.props;
    let appendType;
    let imageUploadUrl;

    if (type == 'create') {
      appendType = 'lcb_uploadaction';
      imageUploadUrl = '/criminal/uploadaction/lcb';
    } else if (type == 'ps') {
      appendType = 'ps_uploadaction';
      imageUploadUrl = '/criminal/uploadaction/ps';
    }

    const fmData = new FormData();
    const config = {
      headers: {
        'accept': 'application/json',
        'Accept-Language': 'en-US,en;q=0.8',
        'Content-Type': `multipart/form-data; boundary=${fmData._boundary}`
      },
    };

    fmData.append(appendType, files && files.file.originFileObj, files && files.file && files.file.name);
    try {
      const res = await axios.post(
        baseUrl + imageUploadUrl, fmData, config);

      if (res.data && res.data.error) {
        message.error('something went wrong !!!');
      } else {
        if (type == 'create') {
          this.createSummova(options, res.data);
        } else if (type == 'ps') {
          this.PSUpdateForm(options, res.data);
        }

      }
    } catch (err) {
      message.error('something went wrong !!!');
    }
  };

  onOpenRequestForm = () => {
    this.setState({ isCreateFormVisible: true, isresetform: true });
  };

  onCloseCreateSpotDrawer = () => {
    this.setState({
      isCreateFormVisible: false,
      isresetform: true
    });
  };

  onCityChange = (cityId, form) => {
    if (cityId) {
      this.setState({isresetform: false});
      this.props.dispatch(professionalAction.getDistrict(cityId, form));
    }
  };

  OpenLSBForm = (values) => {
    this.setState({ updateSaman: values })
    if (values.form == 'lsb1') {
      this.setState({ isform1Visible: true })
    }
    else if (values.form == 'ps1') {
      this.setState({ isform2Visible: true })
    }
  }

  createSummova = (values, file) => {
    let obj = {
      data: {
        ws_javak_type: values.crimetype,
        ws_nond: values.sno,
        ws_date: values.crimedate,
        ws_javak_no: values.crimenumber,
        ws_nemle_date: values.assigneddate,
        ws_member_type: values.criminaltype,
        ws_member_name: values.gurantername,
        ws_member_address: values.address,
        ws_court_name: values.courtname,
        ws_case_no: values.casenumber,
        ws_respective_login: values.district,
        createdby_id: this.props.user.id,
        lcb_uploadaction_filename: file.filename,
        lcb_uploadaction_fileurl: file.s3_object,
        ws_state: values.state,
        ws_city: values.city
      }
    };
    this.props.dispatch(samanAction.saveSamanInformation(obj));
    message.success("Samans record save Successfully!!!");
    this.setState({ loading: true });
    samanAction.getSamansInformation().then(res => {
      if (res.length) {
        this.setState({ loading: false, samansList: res });
      }
    });
  }

  PSUpdateForm = (values, file) => {
    this.setState({ isform2Visible: !this.state.isform2Visible })

    let postData = {
      "data": {
        "ws_status": values.informedtype,
        "ws_sentby": values.posttype,
        "ws_finaldoc_sentdate": values.crimedate,
        "ws_finaldoc_no": values.finaldocno,
        ps_uploacaction_filename: file.filename,
        ps_uploadaction_fileurl: file.s3_object,
        "ps_doneby": this.props.user.id
      }
    }

    this.props.dispatch(samanAction.updatePSSideForm(postData, this.state.updateSaman.value.summons_id));
    message.success("Samans update Successfully!!!");
    this.setState({ loading: true });
    samanAction.getSamansInformation().then(res => {
      if (res.length) {
        this.setState({ loading: false, samansList: res });
      }
    });
  }

  LSBUpdateForm = (values) => {
    this.setState({ isform1Visible: !this.state.isform1Visible })
    let postData = {
      "data": {
        "firstupdate": true,
        "ws_datefetched_ps": values.getdate,
        "ws_handover_name": values.providername,
        "ws_handover_mobile": values.providermobilenumber,
        "lcb_doneby": this.props.user.id,
      }
    }
    this.props.dispatch(samanAction.updatePSSideForm(postData, this.state.updateSaman.value.summons_id));
    message.success("Samans update Successfully!!!");
    this.setState({ loading: true });
    samanAction.getSamansInformation().then(res => {
      if (res.length) {
        this.setState({ loading: false, samansList: res });
      }
    });
  }

  render() {
    const { user, loading } = this.props;

    return (
      <div className="col-md-6 col-md-offset-3" >
        <Spin spinning={loading} >
          <div>
            {user && user.role == '4' && <Button type="primary" style={{ float: 'right', marginBottom: '1rem' }} onClick={this.onOpenRequestForm}>
            जावक नोंदवा
            </Button>}
            <React.Suspense
              fallback={
                <div>
                  Loading...
                </div>
              }>
              <SamansTable
                user={user}
                tableData={this.state.samansList}
                OpenLSBForm={this.OpenLSBForm}
              ></SamansTable>
            </React.Suspense>
          </div>
        </Spin>

        <Drawer title="जावक" placement="right" width={720} closable={true}
          onClose={this.onCloseCreateSpotDrawer} visible={this.state.isCreateFormVisible}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                onClick={this.onCloseCreateSpotDrawer}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>

              <Button onClick={this.onFormSave} type="primary"
                style={{ marginRight: 8 }}
              >
                Submit
              </Button>
            </div>
          }
        >
          <SamanForm ref={this.userForm} onFormFinish={this.onFormFinish} dataStates={this.props.professionals}
            user={user} onCityChange={this.onCityChange} formreset = {this.state.isresetform && this.state.isCreateFormVisible}
          ></SamanForm>
        </Drawer>
        <Modal visible={this.state.isform1Visible} centered onOk={() => { this.lsbForm.current.onFinish(true) }} width={400}
          onCancel={() => this.setState({ isform1Visible: false })}>
          <LCBForm ref={this.lsbForm} onFormFinish={this.LSBUpdateForm} data={this.state.updateSaman}></LCBForm>
        </Modal>

        <Modal visible={this.state.isform2Visible} centered onOk={() => { this.psForm.current.onFinish(true) }} width={400}
          onCancel={() => this.setState({ isform2Visible: false })}>
          <PSForm ref={this.psForm} onFormFinish={this.onFormFinish} data={this.state.updateSaman}></PSForm>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { newsList, gpsInformationList, loading } = professionals;
  
  return {
    user,
    users,
    newsList,
    professionals,
    loading
  };
}

const connectedsamans = connect(mapStateToProps)(Samans);
export { connectedsamans as Samans };
